export default {"src":"/_next/static/media/lawyerTalk_64.9fc59fec.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};